export default {
  date: function (value) {
    let oDate = new Date(value)
    let m = oDate.getMonth() + 1
    let d = oDate.getDate().toString().length > 1 ? oDate.getDate() : '0' + oDate.getDate()
    let h = oDate.getHours().toString().length > 1 ? oDate.getHours() : '0' + oDate.getHours()
    let n = oDate.getMinutes().toString().length > 1 ? oDate.getMinutes() : '0' + oDate.getMinutes()
    return m+'月'+d+'日'+' '+h+':'+n
  },
  status: function (value) {
    if (value) {
      return '兑换成功'
    } else {
      return '正在审核'
    }
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js